import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ProjectRouteStationWithParam } from "../../shared/interfaces/project-route-station.class";
import { Project } from "../../shared/interfaces/project.interface";
import { ProjectImageData } from "../../shared/interfaces/project-image-data.interface";
import { ImageDataService } from "../../shared/services/image-data.service";
import { ProjectDataService } from "../../shared/services/project-data.service";
import { ProjectService } from "../../shared/services/project.service";
import { ImageService } from "../../shared/services/image.service";
import { SetImage } from "../../project-images/shared/set-image.interface";
import { DataEndChannel } from "../../shared/interfaces/data-end-channel.interface";
import { SelectInput } from "../../../shared/dropdown/shared/select-input.class";
import { AlertService } from "../../../shared/alert/shared/alert.service";
import { AlertTypes } from "../../../shared/alert/shared/alert-types";
import { DataEndChannelTypeEnum } from "../../shared/enums/data-end-channel-type.enum";
import { environment } from "../../../../environments/environment";
import { EnergyChartComponent } from '../shared/components/energy-chart/energy-chart.component';
import { CurrentChartComponent } from '../shared/components/current-chart/current-chart.component';
import { StmChartComponent } from '../shared/components/stm-chart/stm-chart.component';
import { Subscription } from 'rxjs';
import { SpeedChartComponent } from '../shared/components/speed-chart/speed-chart.component';
import { SolarDetailsComponent } from '../shared/components/solar-details/solar-details.component';
import { BrennstoffzellenDetailsComponent } from '../shared/components/brennstoffzellen-details/brennstoffzellen-details.component';
import { BrennstoffzellenHistoryComponent } from '../shared/components/brennstoffzellen-history/brennstoffzellen-history.component';
import { WeatherDataDetailsComponent } from '../shared/components/weatherData-details/weatherData-details.component';
import { WeatherDataChartComponent } from '../shared/components/weatherData-chart/weatherData-chart.component';
// import { BrennstoffzellenHistoryComponent } from '../shared/components/brennstoffzellen-history/brennstoffzellen-history.component';

@Component({
  selector: 'avs-schema-route-station-modal',
  templateUrl: './schema-route-station-modal.component.html',
  styleUrls: ['./schema-route-station-modal.component.css']
})
export class SchemaRouteStationModalComponent implements OnInit, OnDestroy {

  private activeProject: Project | undefined;
  public images: ProjectImageData[] = [];

  public AQisKanalSelectOpen: boolean = false;
  public AQkanalSelectInput: SelectInput[] = [];
  public AQselectedKanal: SelectInput | undefined;

  public MQisKanalSelectOpen: boolean = false;
  public MQkanalSelectInput: SelectInput[] = [];
  public MQselectedKanal: SelectInput | undefined;

  public DOisKanalSelectOpen: boolean = false;
  public DOkanalSelectInput: SelectInput[] = [];
  public DOselectedKanal: SelectInput | undefined;

  public DIisKanalSelectOpen: boolean = false;
  public DIkanalSelectInput: SelectInput[] = [];
  public DIselectedKanal: SelectInput | undefined;

  public BarrierIsChannelSelectOpen: boolean = false;
  public BarrierChannelSelectInput: SelectInput[] = [];
  public BarrierSelectedChannel: SelectInput | undefined;
  public BarrierCurrentPositionCode: number | undefined;
  public BarrierBlocked: boolean | undefined;

  public isBlinker: boolean = false;
  protected readonly environment = environment;
  public projectImages: ProjectImageData[] = [];
  public imageIntervalCollection: any[] = [];
  /* public isToday: boolean = false; */
  public showManualControls: boolean = false;


  public projectImageDataSubscribtion: Subscription;
  public imageDataSubscribtion: Subscription;
  public activeProjectSubscription: Subscription;
  public projectDataEndChannelsSubscription: Subscription;
  public projectDataRoutestationSubscription: Subscription;
  public schemaRouteStationSubscriptionCollection: Subscription[] = [];
  constructor(@Inject(MAT_DIALOG_DATA) 
    public data: ProjectRouteStationWithParam,
    private imageDataService: ImageDataService,
    private projectDataService: ProjectDataService,
    private projectService: ProjectService,
    private dialogRef: MatDialogRef<SchemaRouteStationModalComponent>,
    private imageService: ImageService,
    private alertService: AlertService,
    private dialog: MatDialog) {
    this.projectImageDataSubscribtion = imageDataService.projectRouteStationImages.subscribe(images => {
      this.images = images;
      if (images?.length > 0) {
        this.rotateImagesPaths(this.images)
      }
    });
    this.activeProjectSubscription = projectDataService.activeProject.subscribe(project => {
      this.activeProject = project;
    });
    this.projectDataEndChannelsSubscription = projectDataService.dataEndChannels.subscribe(endChannels => {
      this.getManualControlChannels(endChannels);
      this.getKanalSelect(endChannels); /* muss dann in manualControlsMethode ausgeüfhrt werden */

    });
    this.imageDataSubscribtion = imageDataService.projectImages.subscribe(images => {
      this.projectImages = images;
    });
    
    this.projectDataRoutestationSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      if (routeStations) {
          this.BarrierCurrentPositionCode = undefined;
          this.BarrierBlocked = undefined;
          routeStations.forEach(routeStation => {
            if (routeStation.routeStation.samId == this.data.routeStation.samId) {
              this.data = routeStation;
              let barrierData = routeStation.schemaInfo?.barrier?.data;
              this.BarrierCurrentPositionCode = barrierData?.positioningStatus ?? undefined;
              this.BarrierBlocked = !(barrierData?.errorCode == false &&
                barrierData?.localControlEnabled ==false &&
                barrierData?.securityLockEnabled ==false &&
                barrierData?.obstacleDetected ==false &&
                barrierData?.warmUp == false);
            }
          })
      }
    });
  }

  public ngOnInit(): void {
    if (this.activeProject) {
      this.projectService.getAllRouteStationImagesWithStationId(this.activeProject.id, this.data.routeStation.id).subscribe(images => {
        this.imageDataService.updateProjectRouteStationImages(images);
      });
    }
    this.schemaRouteStationSubscriptionCollection.push(this.projectImageDataSubscribtion);
    this.schemaRouteStationSubscriptionCollection.push(this.imageDataSubscribtion);
    this.schemaRouteStationSubscriptionCollection.push(this.activeProjectSubscription);
    this.schemaRouteStationSubscriptionCollection.push(this.projectDataEndChannelsSubscription);
    this.schemaRouteStationSubscriptionCollection.push(this.projectDataRoutestationSubscription);
    this.setDays();
   }

  public ngOnDestroy(): void {
    this.imageIntervalCollection.forEach(id => clearInterval(id));
    this.schemaRouteStationSubscriptionCollection.forEach(sub => sub.unsubscribe());
  }

  public setDays(): void {
    let lastData = new Date(this.data.routeStation.lastData)
    let today = new Date()
    let diff = today.getTime() - lastData.getTime()
    let diffDays = diff / (1000 * 60 * 60 * 24)
    this.data.routeStation.daysOld = diffDays
  }

  public rotateImagesPaths(images: ProjectImageData[]): void {
    images.forEach(image => {
      if (image.isAnimated && image.animatedImageIds!.length > 0) { /* für jedes Bild, das für die RouteStation gesetzt wird, wird nun separat geprüft ob ein animatedImageId vorhanden ist */
        this.rotatePathForId(image)
      }
    });
  }

  public rotatePathForId(image: ProjectImageData): void {
    const myValueList = image.animatedImageIds!;

    let i = 0;
    const idS = setInterval(() => {
      image.path = this.getPathByImageId(myValueList[i++]); /* iteration durchs animatedimage array, und zieht sich dasnn über die id, den path */
      if (i === myValueList.length) {
        i = 0;
      }
    }, 1000);

    this.imageIntervalCollection.push(idS);
  }

  public getPathByImageId(imageId: number) {

    if (this.images) {
      let imageObject = this.images.find((x) => x.imageId == imageId)
      return imageObject?.path ? imageObject.path : 'upload/images/6480/207 - Custom Stellcode.bmp';
    }
    else return
  }

  public onCloseBtnClicked(): void {
    this.dialogRef.close();
  }

  public onDeleteStationFromSchemaClicked(): void {
    this.dialogRef.close({ data: this.data, toDelete: true });
  }
  /* 
    public onShowVoltageDiagramFromSchemaClicked(): void {
      this.dialog.open(VoltageChartComponent, {
        data: this.data,
        height: '98vh',
        width: '98vw'
      });
    }
   */
  public onShowCurrentDiagramFromSchemaClicked(): void {
    this.dialog.open(CurrentChartComponent, {
      data: {
        routeStation: { samId: this.data.routeStation.samId },
        solarDateTime: this.data.schemaInfo?.solar?.data?.dataDateTime
      },
      height: 'auto',
      width: '98vw'
    });
  }

  public onShowSpeedChartFromSchemaClicked(): void {
    this.dialog.open(SpeedChartComponent, {
      data: { data: this.data, projectId: this.activeProject?.id },
      height: '75vh',
      width: '75vw'
    })
  }

  public onShowEnergieDiagramFromSchemaClicked(): void {
    this.dialog.open(EnergyChartComponent, {
      data: this.data,
      height: '98vh',
      width: '98vw'
    });
  }
  public onShowBrennstoffZellenVerlaufFromSchemaClicked(): void {
    this.dialog.open(BrennstoffzellenHistoryComponent, {
      data: { data: this.data },
        height: '80vh',
        width: '98vw'
    })
  }

  public onShowSolarDetailsFromSchemaClicked(): void {
    this.dialog.open(SolarDetailsComponent, {
      data: { data: this.data },
      /*   height: '70vh',
        width: '90vw' */
    })
  }
  public onShowBrennstoffzellenDetailsFromSchemaClicked(): void {
    this.dialog.open(BrennstoffzellenDetailsComponent, {
      data: { data: this.data },
      /*   height: '70vh',
        width: '90vw' */
    })
  }

  public onShowSTMDiagramFromSchemaClicked(): void {
    this.dialog.open(StmChartComponent, {
      data: this.data,
      height: '80vh',
      width: '98vw'
    });
  }
  public onShowWeatherDataDetailsFromSchemaClicked(): void {
    this.dialog.open(WeatherDataDetailsComponent, {
      data: { data: this.data },
      /*   height: '70vh',
        width: '90vw' */
    })
  }
  public onShowWeatherDataVerlaufFromSchemaClicked(): void {
    this.dialog.open(WeatherDataChartComponent, {
      data: { data: this.data },
        height: '80vh',
        width: '98vw'
    })
  }

  public onCloseAndNavigateToStation(): void {
    this.dialogRef.close({ data: this.data, navigate: true });
  }

  public AQonKanalSelectClicked(): void {
    this.AQisKanalSelectOpen = !this.AQisKanalSelectOpen;
    /*  wenn erweiterung kommt:
    
    
    OnKanal change (falls überhaupt merhere aqKanäle gefunden werden)
    muss die neue aqManualControl ausgelesen werden
    
    
    
    
    
    */


  }

  public AQonKanalSelectValueChange(event: SelectInput): void {
    let selectedChannel = this.aqControlDataEndChannels.filter(e => e.de === event.id);
    this.selectedAqChannel = selectedChannel.length > 0 ? selectedChannel[0] : undefined;
    /* aqcontrol abgleich über die event id, und dann habe ich den ausgewählten kanal */
    /* filteredChannels und dann den channel mit dem entsprechenden deKanal raussuchen s */
    this.AQselectedKanal = event;
    this.AQisKanalSelectOpen = false;
  }
  public BarrierOnChannelSelectClicked(): void {
    this.BarrierIsChannelSelectOpen = !this.BarrierIsChannelSelectOpen; 
  }
  public BarrierOnChannelSelectValueChange(event: SelectInput): void {
    let selectedChannel = this.barrierControlDataEndChannels.filter(e => e.de === event.id);
    this.selectedBarrierChannel = selectedChannel.length > 0 ? selectedChannel[0] : undefined;
    /* aqcontrol abgleich über die event id, und dann habe ich den ausgewählten kanal */
    /* filteredChannels und dann den channel mit dem entsprechenden deKanal raussuchen s */
    this.BarrierSelectedChannel = event;
    this.BarrierIsChannelSelectOpen = false;
  }

  public MQonKanalSelectClicked(): void {
    this.MQisKanalSelectOpen = !this.MQisKanalSelectOpen;
  }

  public MQonKanalSelectValueChange(event: SelectInput): void {
    this.MQselectedKanal = event;
    this.MQisKanalSelectOpen = false;
    let selectedChannel = this.mqControlDataEndChannels.filter(e => e.de === event.id);
    this.selectedMqChannel = selectedChannel.length > 0 ? selectedChannel[0] : undefined;
  }

  public DOonKanalSelectClicked(): void {
    this.DOisKanalSelectOpen = !this.DOisKanalSelectOpen;
  }

  public DOonKanalSelectValueChange(event: SelectInput): void {
    this.DOselectedKanal = event;
    this.DOisKanalSelectOpen = false;
    let selectedChannel = this.doControlDataEndChannels.filter(e => e.de === event.id);
    this.selectedDoChannel = selectedChannel.length > 0 ? selectedChannel[0] : undefined;
  }

  public DIonKanalSelectClicked(): void {
    this.DIisKanalSelectOpen = !this.DIisKanalSelectOpen;
  }

  public DIonKanalSelectValueChange(event: SelectInput): void {
    this.DIselectedKanal = event;
    this.DIisKanalSelectOpen = false;
    let selectedChannel = this.diControlDataEndChannels.filter(e => e.de === event.id);
    this.selectedDiChannel = selectedChannel.length > 0 ? selectedChannel[0] : undefined;
  }

  flasherControlFound: boolean = false;
  selectedFlasherChannel: DataEndChannel | undefined;
  selectedFlasherChannelId: number = 0;

  aqControlStellcode: number = 0;
  showDoControl: boolean = false;
  showDiControl: boolean = false;
  showAqControl: boolean = true;
  showMqControl: boolean = false;
  showFlasherControl: boolean = false;
  showBarrierControl: boolean = true;


  aqControlFound: boolean = false;
  mqControlFound: boolean = false;
  doControlFound: boolean = false;
  diControlFound: boolean = false;
  barrierControlFound: boolean = false;

  aqControlDataEndChannels: DataEndChannel[] = [];
  mqControlDataEndChannels: DataEndChannel[] = [];
  doControlDataEndChannels: DataEndChannel[] = [];
  diControlDataEndChannels: DataEndChannel[] = [];
  barrierControlDataEndChannels: DataEndChannel[] = [];
  flasherControlDataEndChannels: DataEndChannel[] = [];

  selectedAqChannelId: number = 0;

  selectedAqChannel: DataEndChannel | undefined;
  selectedMqChannel: DataEndChannel | undefined;
  selectedDoChannel: DataEndChannel | undefined;
  selectedDiChannel: DataEndChannel | undefined;
  selectedBarrierChannel: DataEndChannel | undefined;

  aqControlActive: boolean = false;
  mqControlActive: boolean = false;
  doControlActive: boolean = false;
  diControlActive: boolean = false;
  flasherControlActive: boolean = false;

  public onSetImageForSetAqControl(stellcode: number): void {
    this.aqControlStellcode = stellcode
  }

  public onHideAQClick(): void {
    this.showAqControl = !this.showAqControl;
  }
  public onHideMQClick(): void {
    this.showMqControl = !this.showMqControl;
  }
  public onHideDOClick(): void {
    this.showDoControl = !this.showDoControl;
  }
  public onHideDIClick(): void {
    this.showDiControl = !this.showDiControl;
  }
  public onHideBarrierClick(): void {
    this.showBarrierControl = !this.showBarrierControl;
  }

  public onHideDiControlClick(): void {
    this.showDiControl = !this.showDiControl;
  }
  public onHideFlasherControlClick(): void {
    this.showFlasherControl = !this.showFlasherControl;
  }

  public AQManualControlsPreselectedCode: number = 0;

  private getKanalSelect(endChannels: DataEndChannel[]): void {

    this.aqControlDataEndChannels = [];
    this.AQkanalSelectInput = [];
    this.aqControlActive = false;
    for (let filteredChannel of endChannels.filter(e =>
      (e.fg === 4) && !(e.de === 2 && e.localbusAddress === 6) && (e.de < 190))) {
      this.aqControlDataEndChannels.push(filteredChannel);
      let selectInput = {
        name: 'Kanal ' + filteredChannel.de,
        id: filteredChannel.de,
        dataEndChannelType: filteredChannel.dataEndChannelType
      } as SelectInput
      this.AQkanalSelectInput.push(selectInput);
    }
    this.AQselectedKanal = this.AQkanalSelectInput.find(k => k.id === this.aqControlDataEndChannels[0]?.de); /* default auf den ersten Kanal setzen */
    this.selectedAqChannel = this.aqControlDataEndChannels[0];

    let blinker = endChannels.find(e => (e.de === 2) && (e.fg === 4) && e.localbusAddress === 6);
    if (blinker) { this.isBlinker = true; }

    if (this.aqControlDataEndChannels.length > 0) {
      if (this.aqControlDataEndChannels[0].manualControl !== null) {
        let parsedManualControlSettings = JSON.parse(this.aqControlDataEndChannels[0].manualControl.settings);

        this.aqControlActive = parsedManualControlSettings.AQ.Active;
        this.AQManualControlsPreselectedCode = parsedManualControlSettings.AQ.Code;
      }
    }
  }

  private getMqKanalSelect(endChannels: DataEndChannel[]): void {

    /* filterung auslagern */
    this.mqControlDataEndChannels = [];
    this.MQkanalSelectInput = [];
    this.mqControlActive = false;
    for (let filteredChannel of endChannels.filter(e =>
      (e.fg === 1))) {
      this.mqControlDataEndChannels.push(filteredChannel);
      let selectInput = {
        name: 'Kanal ' + filteredChannel.de,
        id: filteredChannel.de,
        dataEndChannelType: filteredChannel.dataEndChannelType
      } as SelectInput
      this.MQkanalSelectInput.push(selectInput);
    }

    if (this.mqControlDataEndChannels.length > 0) {
      this.mqControlDataEndChannels.forEach(channel => {
        if (channel.manualControl !== null) {
          let parsedManualControlSettings = JSON.parse(channel.manualControl.settings);
          let mqState = parsedManualControlSettings.MQ?.State;
          let mqActive = parsedManualControlSettings.MQ?.Active;
          if (mqActive) {
            this.activeMQDeChannelArr.push(channel.de);
          }
        }
        if (this.activeMQDeChannelArr.length > 0) {
          this.mqControlActive = true;
        }
      })

    }
  }

  public parsedDoManualControl?: boolean;
  private getDoKanalSelect(endChannels: DataEndChannel[]): void {
    this.doControlDataEndChannels = [];
    this.DOkanalSelectInput = [];
    this.doControlActive = false;
    for (let filteredChannel of endChannels.filter(e =>
      (e.fg === 6) && (e.de === 7))) {
      this.doControlDataEndChannels.push(filteredChannel);
      let selectInput = {
        name: 'Kanal ' + filteredChannel.de,
        id: filteredChannel.de,
        dataEndChannelType: filteredChannel.dataEndChannelType
      } as SelectInput
      this.DOkanalSelectInput.push(selectInput);
    }
    this.selectedDoChannel = this.doControlDataEndChannels[0]; /* default auf den ersten Kanal setzen */
    this.DOselectedKanal = this.DOkanalSelectInput.find(k => k.id === this.doControlDataEndChannels[0]?.de);

    if (this.doControlDataEndChannels.length > 0) {
      if (this.doControlDataEndChannels[0].manualControl !== null) {

        let parsedManualControlSettings = JSON.parse(this.doControlDataEndChannels[0].manualControl.settings);
        this.parsedDoManualControl = parsedManualControlSettings.DO.State
        this.doControlActive = parsedManualControlSettings.DO.Active;
      }
    }
  }

  public parsedDiManualControl?: boolean;
  public activeDigitalInputDeChannelArr: number[] = [];
  public activeMQDeChannelArr: number[] = [];

  private getDiKanalSelect(endChannels: DataEndChannel[]): void {
    this.diControlDataEndChannels = [];
    this.DIkanalSelectInput = [];
    this.diControlActive = false;
    // You can add a DIkanalSelectInput if you want to support a dropdown for DI as well
    for (let filteredChannel of endChannels.filter(e =>

      (e.fg === 6) && (e.de === 1 || e.de === 2 || e.de === 3 || e.de === 4)

    )) {
      this.diControlDataEndChannels.push(filteredChannel);
      let selectInput = {
        name: 'Kanal ' + filteredChannel.de,
        id: filteredChannel.de,
        dataEndChannelType: filteredChannel.dataEndChannelType
      } as SelectInput
      this.DIkanalSelectInput.push(selectInput);
      // Add select input logic here if needed
    }
    this.selectedDiChannel = this.diControlDataEndChannels[0]; // default auf den ersten Kanal setzen
    this.DIselectedKanal = this.DIkanalSelectInput.find(k => k.id === this.diControlDataEndChannels[0]?.de);

    if (this.diControlDataEndChannels.length > 0) {
      this.diControlDataEndChannels.forEach(channel => {
        if (channel.manualControl !== null) {
          let parsedManualControlSettings = JSON.parse(channel.manualControl.settings);
          let diState = parsedManualControlSettings.DI?.State;
          let diActive = parsedManualControlSettings.DI?.Active;
          if (diActive) {
            this.activeDigitalInputDeChannelArr.push(channel.de);
          }
        }
        if (this.activeDigitalInputDeChannelArr.length > 0) {
          this.diControlActive = true;
        }
      })
    }
  }
  private getBarrierKanalSelect(endChannels: DataEndChannel[]): void {

    this.barrierControlDataEndChannels = [];
    this.BarrierChannelSelectInput = [];
    for (let filteredChannel of endChannels.filter(e =>
      (e.dataEndChannelType === DataEndChannelTypeEnum.LANESWITCH) || (e.dataEndChannelType === DataEndChannelTypeEnum.BAR) ||  (e.dataEndChannelType === DataEndChannelTypeEnum.SWING))) {
      this.barrierControlDataEndChannels.push(filteredChannel);
      let selectInput = {
        name: 'Kanal ' + filteredChannel.de,
        id: filteredChannel.de,
        dataEndChannelType: filteredChannel.dataEndChannelType
      } as SelectInput
      this.BarrierChannelSelectInput.push(selectInput);
    }
    this.BarrierSelectedChannel = this.BarrierChannelSelectInput.find(k => k.id === this.barrierControlDataEndChannels[0]?.de); /* default auf den ersten Kanal setzen */
    this.selectedBarrierChannel = this.barrierControlDataEndChannels[0];

    /*if (this.barrierControlDataEndChannels.length > 0) {
      if (this.barrierControlDataEndChannels[0].manualControl !== null) {
        let parsedManualControlSettings = JSON.parse(this.aqControlDataEndChannels[0].manualControl.settings);

        this.aqControlActive = parsedManualControlSettings.AQ.Active;
        this.AQManualControlsPreselectedCode = parsedManualControlSettings.AQ.Code;
      }
    }*/
  }

  private getManualControlChannels(endChannels: DataEndChannel[]): void {
    if (!endChannels || endChannels.length === 0) {
      return;
    }
    this.doControlDataEndChannels = [];
    this.aqControlDataEndChannels = [];
    this.mqControlDataEndChannels = [];
    this.diControlDataEndChannels = [];
    this.doControlFound = false;
    this.aqControlFound = false;
    this.mqControlFound = false;
    this.diControlFound = false;
    this.barrierControlFound = false;
    this.activeDigitalInputDeChannelArr = [];
    /* doControl */
    let doControlChannels = endChannels.filter(e => e.fg === 6 && e.de === 7);
    if (doControlChannels.length > 0) {
      this.doControlFound = true;
      this.getDoKanalSelect(doControlChannels);
      this.doControlDataEndChannels = doControlChannels;
      this.selectedDoChannel = doControlChannels[0]; /* default auf den ersten Kanal setzen */
    }
    /* diControl */
    let diControlChannels = endChannels.filter(e => e.fg === 6 && (e.de === 1 || e.de === 2 || e.de === 3 || e.de === 4));
    if (diControlChannels.length > 0) {
        this.diControlFound = true;
      this.getDiKanalSelect(diControlChannels);
/*           this.diControlDataEndChannels = diControlChannels;
 */          this.selectedDiChannel = diControlChannels[0];
    }
    /* aqControl */
    let aqControlChannels = endChannels.filter(e => e.dataEndChannelType === DataEndChannelTypeEnum.LED ||
      e.dataEndChannelType === DataEndChannelTypeEnum.PW);    
    if (aqControlChannels.length > 0) {
      this.aqControlFound = true
    }

    /* mqControl */
    let mqControlChannels = endChannels.filter(e => e.fg === 1); /* hier die filterungen einbauen fg == 1 / de / ea? */
    if (mqControlChannels.length > 0) {
      this.mqControlFound = true;
      this.getMqKanalSelect(mqControlChannels);
      /* falcon, sm, adec... nach allen suchen, nochmal prüfen wie am besten */

    }
  /* barrierControl */
    let barrierChannels = endChannels.filter(e => e.dataEndChannelType ===  DataEndChannelTypeEnum.LANESWITCH || e.dataEndChannelType ===  DataEndChannelTypeEnum.BAR || e.dataEndChannelType ===  DataEndChannelTypeEnum.SWING); 
    if (barrierChannels.length > 0) {
      this.barrierControlFound = true;
      this.getBarrierKanalSelect(barrierChannels); 
      this.barrierControlDataEndChannels = barrierChannels;
      this.selectedBarrierChannel = barrierChannels[0]; /* default auf den ersten Kanal setzen */
    }

    let flasherControlChannels = endChannels.filter(e => e.fg === 4 && e.de === 2 && e.localbusAddress === 6 && e.dataEndChannelType === DataEndChannelTypeEnum.BLINKER);;
    if (flasherControlChannels.length > 0) {
      this.flasherControlFound = true;
      this.flasherControlDataEndChannels = flasherControlChannels;
      this.selectedFlasherChannel = flasherControlChannels[0];
      this.selectedFlasherChannelId = this.selectedFlasherChannel.id;
      if (flasherControlChannels.length > 0) { }
      if (flasherControlChannels[0].manualControl !== null) {
        let parsedManualControlSettings = JSON.parse(flasherControlChannels[0].manualControl.settings);
        this.flasherControlActive = parsedManualControlSettings.AQ.Active;
      }
    }
  }

  // function to check if schemaInfo.lastData is less then 14 days old

  public isDataOlderThan14Days(): boolean {
    let lastData = this.data.routeStation.lastData;
    let lastDataDate = new Date(lastData);
    let currentDate = new Date();
    let diff = currentDate.getTime() - lastDataDate.getTime();
    let diffDays = diff / (1000 * 60 * 60 * 24);
    if (diffDays > 14) {
      return true;
    } else {
      return false;
    }
  }


  activeDigitalInputs(): string {
    return 'manuelle Steuerung bei Kanälen: ' + this.activeDigitalInputDeChannelArr.join(', ') + ' aktiv';
  }

  activeMQs(): string {
    return 'manuelle Steuerung bei Kanälen: ' + this.activeMQDeChannelArr.join(', ') + ' aktiv';
  }
}
